<mat-expansion-panel>
    <mat-expansion-panel-header (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-panel-title>
            <mat-checkbox [color]="color" (click)="$event.stopPropagation()" [checked]="allComplete"
                [indeterminate]="someComplete()" (change)="setAll($event.checked)" >
                {{tags.tagTypeName}}
            </mat-checkbox>
        </mat-panel-title>

    </mat-expansion-panel-header>
    <ul>
        <li *ngFor="let sbt of tags?.tags">
            <mat-checkbox [color]="color" [(ngModel)]="sbt.completed" [checked]="sbt.completed"
                (ngModelChange)="updateAllComplete()" (click)="addOrDeleteTag(sbt)">
                {{sbt?.tagName}}
            </mat-checkbox>
        </li>
    </ul>

</mat-expansion-panel>